import React, {useState, useContext} from 'react';
import firebase from 'firebase';

import { Button, Dropdown, Input, Modal } from 'semantic-ui-react';

import {GlobalContext} from '../contexts/GlobalContext';


const GeneratedScheduleModal = (props) => {

    const quals = [
        { key: 'M4', text: 'M4', value: 'M4' },
        { key: 'POOW', text: 'POOW', value: 'POOW' },
        { key: 'MOOW', text: 'MOOW', value: 'MOOW' },
    ]

    const [name, setName] = useState('');
    const [qualifications, setQualifications] = useState([]);
    const [timeslot, setTimeslot] = useState('');

    const [state, setState] = useContext(GlobalContext);


    const updateName = (e) => {
        setName(e.target.value);
    }
    
    const updateQuals = (e, data) => {
        setQualifications(data.value);
    }

    const updateTimeslot = (e) => {
        setTimeslot(e.target.value);
    }
    
    return (
        <div>

            <Modal dimmer='blurring' open={props.show}
            >
            <Modal.Header>Schedule Generated</Modal.Header>
            <Modal.Content>
            {

                state['schedule'] ?
                    state['schedule'].map(position => (
                        <div>
                        <h3>{position['position'].name} - {position['position'].timeslot}</h3>
                        {position['employee'] ? <h4>{position['employee'].name}</h4> : <h4 style={{color:'red'}}>Unfilled</h4>}
                        {/* <h4>{position['employee'] ? position['employee'].name : 'Unfilled'}</h4> */}
                        <br />
                        </div>
                    )) : <p>No positions</p>

            }
            </Modal.Content>
            <Modal.Actions>
                <Button negative onClick={props.onClose} >
                Cancel
                </Button>
                <Button positive onClick={props.onClose} >
                Continue
                </Button>
            </Modal.Actions>
            </Modal>
        </div>
    );
};

export default GeneratedScheduleModal;